import { Select } from 'jl-design-system/components/select/Select';

export const PRODUCT_TYPE = {
  component: Select,
  name: 'productId',
  id: 'productId',
  label: 'Product type',
  options: [{ value: '', label: 'Select a product type' }],
  required: true,
  validationMessageKeys: {
    required: 'Please select a product type',
  },
  className: 'fieldMedium',
};
